module.exports = __webpack_public_path__ + "img/teaser_pferd10.8e8d8333.jpg";